import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg text-foreground-900 mb-4">
              写作技巧大全
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注中小学生作文写作指导，提供优质范文、专业写作技巧与丰富素材，帮助孩子爱上写作、提升语文能力。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              写作分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/na-yi-ci-wo-xuehui-le-chengshi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  那一次，我学会了诚实
                </Link>
              </li>
              <li>
                <Link to="/article/ruhe-xiehao-chengzhang-gushi-de-kaitou" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  如何写好成长故事的开头
                </Link>
              </li>
              <li>
                <Link to="/article/yong-xijie-dadong-duzhe-wugan-miaoxiefa" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  五感描写法实战指南
                </Link>
              </li>
              <li>
                <Link to="/article/jixuwen-qi-cheng-zhuan-he-jiegou" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  记叙文起承转合结构详解
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="#contact-form" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 写作技巧大全 版权所有 | 本站内容仅供学习参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}